module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "cn",
    attrs: {
      "id": "_idParaDest-16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062948052_Contents#r_idParaDest-16"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_47",
      "title": "47"
    }
  }, [_c('b', [_vm._v("7")])])])]), _vm._v(" "), _c('h2', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062948052_Contents#r_idParaDest-16"
    }
  }, [_vm._v("Haley-Anne")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("G")]), _c('span', {
    staticClass: "make_smallcaps"
  }, [_vm._v("US WAKES FROM A STICKY SLEEP TO A BRIGHT AND SUNNY")]), _vm._v(" Saturday morning. She’s anything but sunny. In fact, a blue melancholy seems to have crept into her bed overnight. She rises and stumbles downstairs to escape it. And before her morning coffee can make its way into her bloodstream, the real estate agent pops by for a "), _c('i', [_vm._v("look-see")]), _vm._v(". Haley-Anne crunches her nose at the smells radiating from the musty armpits of Rose’s house. High heels clicking across the hardwood like two tiny hammers tapping away at the soft tissue of Augusta’s fragile dream-soaked brain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The place definitely needs some serious spit and polish, top to bottom, inside and out. And then it’ll be all about the staging for MBV.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Haley-Anne blinks. Gus stares at her like she’s speaking Swahili.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maximum buyer visualization? MBV. I came up with that. A potential buyer needs to be able to see themselves "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_48",
      "title": "48"
    }
  }, [_vm._v("cooking dinner for the fam, planting petunias in the garden, entertaining the in-laws, even if her mother-in-law is a judgmental old B. It’s the life that we’re selling, not the house.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gus gets that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That crack in the ceiling.” Eye roll.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That yellow toilet.” Nostril flare.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That torn screen.” Big sigh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And that hideous brown lawn.” Shoulder slump.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Weed that garden, roll out some fresh sod, put a couple of potted mums on the porch, et voilà! Curb appeal!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Haley-Anne hands her an inventory of to-dos as she leaves. Gus promises she’ll get right on it. The bank has given her three months, so the sooner they list the house, the better. Gus posts the to-dos on the fridge under a puppy magnet. She stares at it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("How hard can it be to create curb appeal and clean up a little?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harder than she thinks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_b"
  }, [_vm._v("Gus spends the weekend moving from room to room like a balloon bouncing off the furniture. The melancholy follows her as she hovers in doorways. Gets sucked down halls. And occasionally clings to a wall while Lars sends her text after text.")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Babes, where you at?")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("What the fuck, Augs?")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Please come back.")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("You’re dead to me.")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("I love you, Auggie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_t"
  }, [_vm._v("She runs her fingers along dusty windowsills where paint peels away in lovely cracked patterns that remind her of the backs of Rose’s wrinkled hands. She stares through cobwebs "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_49",
      "title": "49"
    }
  }, [_vm._v("crisscrossing the front window as the world outside moves past, a carousel of mothers and strollers, dog walkers, a postman shouldering a heavy bag, a garbage truck wincing as it stops and starts. All moving past Rose’s house. Unaware that Gus is watching from behind the cobwebs.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miss Santos probably looked out this same window as life passed her by. Waiting for an old woman to take her last breath so she could collect on a promise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gus has been at Rose’s house since Thursday evening. It takes her until Monday to move herself into the room where Miss Santos used to sleep. The smallest, starkest bedroom in the house. The one with the single bed in the corner and the TV sitting across from it, knowing its blue flickering will keep her company at night. She closes the door to the periwinkle guest room that used to be hers and leaves it closed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Levi has been sleeping on Rose’s bed. Every evening after supper, Gus hears his nails "), _c('i', [_vm._v("tick-tick-tick")]), _vm._v(" up the wooden stairs and down the hall. Then the soft squeak of the box spring as he hoists his old bones up onto the bed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tuesday, Gus stumbles into the kitchen wearing one of Rose’s long flannel nightgowns. She found a stack of them neatly washed and folded on top of a hamper. Made of soft cotton that reminds her of the nighties she used to wear as a kid. Gus sits at the kitchen table with her coffee, just like she has the previous four mornings. The to-do list waiting on the fridge. Levi at her feet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Wednesday, she pokes around upstairs. Opening the drawer in the small teak table next to Rose’s bed. Three linen dollies, a melted candle, matches, a Bible, and a small handgun along with a box of bullets tucked underneath a half-dozen "), _c('i', [_vm._v("Reader’s Digest")]), _vm._v("s.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_50",
      "title": "50"
    }
  }, [_vm._v("In the closet, Gus finds a collection of hatboxes, a different colored hat inside each. Pink, plum, daisy yellow, and pistachio. Sunday hats. Each a delicate pastel bouquet resting inside a satin coffin. Some gilded with pearls. Others decorated with feathers or tiny silk roses. She opens the daisy yellow box and tries on the hat. Sitting in front of Rose’s vanity, she pulls a strand of gray hair from the rim. It’s caught in a pearl.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A remnant of Rose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the vanity sits a hand-carved jewelry box. Its velvet-lined pockets are brimming with bangles and shiny rings and rhinestone necklaces coiled like sleeping snakes. Costume jewelry. Cubic zirconia and simulated diamonds. Lars used to deal in junk jewelry. She knows it well. Gus clips on a pair of dangly earrings and looks in the mirror.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A child playing dress-up stares out at her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She dips back in time.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-040725df","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062948052_Chapter_7.vue
// module id = 93
// module chunks = 0